"use client";

import { Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AccessibilityContact() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="επικοινωνία-για-προβλήματα-προσβασιμότητας" className="py-16 md:py-24 bg-background">
      <div ref={ref} className={`container mx-auto px-4 max-w-3xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Card className="border-border shadow-md text-center overflow-hidden">
          <div className="bg-primary/5 py-8">
            <CardHeader className="pb-0">
              <div className="mx-auto bg-primary/10 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                <Mail className="w-8 h-8 text-primary" />
              </div>
              <CardTitle className="text-2xl md:text-3xl font-default text-foreground">
                Αν Αντιμετωπίσετε Προβλήματα Προσβασιμότητας
              </CardTitle>
            </CardHeader>
          </div>
          <CardContent className="pt-8 pb-10 flex flex-col items-center gap-8 px-6 md:px-12">
            <p className="text-muted-foreground text-lg font-default leading-relaxed max-w-2xl">
              Δεσμευόμαστε να παρέχουμε έναν ιστότοπο πλήρως προσβάσιμο σε όλους τους χρήστες. 
              Αν συναντήσετε οποιοδήποτε εμπόδιο κατά την πλοήγησή σας ή έχετε προτάσεις 
              για τη βελτίωση της εμπειρίας σας, παρακαλούμε επικοινωνήστε μαζί μας. 
              Η ανατροφοδότησή σας είναι πολύτιμη για εμάς.
            </p>
            <Button asChild size="lg" className="font-default text-base h-12 px-8">
              <Link to="mailto:reservations@hoteldeals.gr">
                <Mail className="mr-2 w-5 h-5" />
                reservations@hoteldeals.gr
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </section>;
}